module.exports = __webpack_public_path__ + "static/media/SquiggleYellow.c6f01cd1.svg";